import { Box, styled } from '@mui/material'

export const ContainerBody = styled(Box)(() => ({
  overflow: 'hidden',
}))
